export const formatMonth = new Intl.DateTimeFormat('en-US', {
  year: 'numeric', 
  month: 'long',
})
